import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — DashShell : repli/déploiement de la sidebar.
 * Spec : docs/design-system/REFERENCE.md §6.4
 */
export default class extends Controller {
  static targets = ["sidebar"];

  toggle() {
    if (this.hasSidebarTarget) this.sidebarTarget.classList.toggle("is-collapsed");
  }
}
